export enum FileObjectStatus {
    NotStarted,
    Uploading,
    Uploaded,
    Canceled,
    Deleted,
    Failed
}

export class  FileObject {
    status = FileObjectStatus.NotStarted;
    type: string;
    name: string;
    constructor(public file: File, type: string) {
        this.type = type;
        this.name = this.file.name;
    }
}

export class Uploads {
    uploadType: string;
    index: number;
    path: string;
    files: FileObject[];
}

export class Analyte {
    analyteName: string;
    uploadObjs: Uploads[];
    tempPath: string;
    constructor(name) {
        this.analyteName = name;
        this.uploadObjs = [];
    }
}

export class AnalysisDetails {
    userId: string;
    analysisId: string;
    analysisStatus?: string;
    analysisType?: string;
    analysisSubtype?: string;
    projectCode_AP?: string;
    analyteName: string;
    analytes?: Analyte[];

    constructor(userId) {
        this.userId = userId;
        this.analysisId = Math.floor(new Date().getTime() / 1000.0).toString();
        this.analysisType = '';
        this.analytes = [];
    }
}

export interface UploadedFiles {
    type: string,
    name: string
}

export interface DropDowns {
    key: string;
    values: DropDown[]
}

export interface DropDown {
    name: string;
    desc: string;
}

export interface SearchResult {
    userId: string;
    userName: string;
    analysisId: string;
    analysisDate?: string;
    analysisType: string;
    analysisSubtype?: string;
    analysisTypeDisplay?: string;
    analysisResult?: string;
    analysisResultFile?: string;
    analysisResultData?: string;
    AnalysisResultXlsxFile?: string;
    analysisStatus?: string;
    analysisDetails?: string;
    selectedTables?: string;
    analyteName?: string;
    projectNames?: string;
    tableData?: string;
    tableReselection?: number;
    AnalysisResultGraph?: string;
    ParsedDataPath?: string;
}

export class UserData {
    data: SearchResult[]
}

export interface AnalysisData {
    data: SearchResult
}

export  class PreviousAnalysisData {
    data: AnalysisKey[];
}

export class PreviousAnalysis {
    userId: string;
    analysisId: string;
    analysisKey: string;
}

// export class RDSAnalysisData {
//     user_id: string;
//     organization_id: string;
//     group_id: string;
//     analysis_id: string;
//     file_name: string;
//     analysis_type: string;
//     analysis_date?: string;
//     project_code: string;
//     analysis_status?: string;
// }
export class AnalysisKey {
    userId: string;
    analysisId: string;
    organizationId?: string;
    groupId?: string;
    analysisDate?: string;
    analysisType: string;
    analysisSubtype?: string;
    analyteName?: string[];
    projectCodeSA?: string;
    projectCode_AP?: string;
    projectCodeMV?: string;
    projectNames?: string;
    fileName?: string;
    analysisTypeDisplay?: string;
    analysisSubtypeDisplay?: string;
}

export class Dashboard {
    userId: string;
    analysisDate: Date;
    analyteNames: string[];
    analysisType: string;
    analysisSubtype?: string;
    projectCodeSA?: string;
    projectCodeMV?: string;
}

export class Summary {
    count: [];
    date: [];
    sumamry_array: AnalysisSummary[]

}

export class AnalysisSummary {
    userId: string;
    analysisId: string;
    overall_g: number;
    overall_y: number;
    overall_r: number;
    date: string;
    analytes: string[];
    projectCodeSA: string;
    projectCodeMV: string;
    analysisType: string;
    analysisSubtype: string;

}

export class Chromatogram {
    file_name: string;
    analysis_result: ChromatogramResult[];
    graphs: ChromatogramGraphs[];

}

export class ChromatogramResult {
    test_name: string;
    category: string;
    details: number;
}

export class ChromatogramFiles {
    type: string;
    key: string;
}

export class ChromatogramGraphs {
    type: string;
    key: string;
}

export  class Logs {
    data: string;
    users: string;
    file: string;
}
export class AuthLog {
    userId: string;
    eventType: string;
    creationDate: string;
    eventResponse: string;
    // riskLevel: string;
    ipAddress: string;
    city: string;
}
export class AWSResponse {
    processcode: string;
    message: string;
    analysisID: string;
}

export interface Result {
    heading: string;
    resultItem: ResultItem[];
    green: string;
    yellow: string;
    red: string;
}
export interface ResultItem {
    tabletype: string;
    item: Item[];
}
export interface Item {
    color: string;
    colorCode?: string;
    message: string[];
}
export interface Table {
    analyte_name: string;
    table_type: string;
    table_index: string;
    table_title: string;
    analysis_type: string;
    rows: string;
    valid: boolean
}
export class Templates {
    type: string;
    description: string;
    columns: TemplateDetail[];
}
export class TemplateDetail {
    name: string;
    desc: string;
    type: string;
    keys: string[];
    required: boolean;
}


